import { Route } from 'vue-router';

export const AiRoute: Record<string, Partial<Route>> = {
  CLARA: {
    path: 'clara',
    name: 'clara'
  },
  CLARA_V2: {
    path: 'clara-v2',
    name: 'clara-v2'
  },
  ASK_CLARA: {
    path: 'ask-clara',
    name: 'ask-clara'
  },
  CONTENT_LIBRARY: {
    path: 'content-library',
    name: 'content-library'
  },
  CONTENT_LIBRARY_SOURCE: {
    path: 'content-library/source',
    name: 'content-library/source'
  }
};
